import { getRegionKey } from "./region-utils";

export function getPrivacyPolicyUrl(language?: string): string {
  const regionUrlMap: Record<string, string> = {
    ca: "https://certn.co/privacy-policy/",
    uk: "https://certn.co/emea/privacy-policy/",
    au: "https://certn.co/anz/privacy-policy/",
    us: "https://certn.co/us/privacy-policy/",
  };

  if (language?.trim().toLowerCase().startsWith("fr")) {
    return "https://certn.co/politique-de-confidentialite/";
  }

  try {
    const region = getRegionKey()?.toLowerCase();
    return regionUrlMap[region] ?? regionUrlMap.ca;
  } catch (error) {
    console.error("Error getting region key:", error);
    return regionUrlMap.ca;
  }
}

export function getApplicantRegistrationPrivacyPolicyUrl(
  language?: string
): string {
  if (language?.trim().toLowerCase().startsWith("fr")) {
    return "https://certn.co/politique-de-confidentialite/";
  }

  const regionUrlMap: Record<string, string> = {
    ca: "https://certn.co/privacy-policy/?version=3",
    uk: "https://certn.co/emea/privacy-policy/",
    au: "https://certn.co/anz/privacy-policy/",
    us: "https://certn.co/us/privacy-policy/",
  };

  try {
    const region = getRegionKey()?.toLowerCase();
    return regionUrlMap[region] ?? regionUrlMap.ca;
  } catch (error) {
    console.error("Error getting region key:", error);
    return regionUrlMap.ca;
  }
}

export function getApplicantPortalTermsOfUseUrl(language: string | undefined) {
  if (language?.toLowerCase().startsWith("fr")) {
    return "https://certn.co/conditions-dutilisation-du-demandeur/";
  }
  return "https://certn.co/applicant-terms-of-use/";
}

export function getServiceAgreementUrl(language?: string): string {
  const regionUrlMap: Record<string, string> = {
    ca: "https://certn.co/service-agreement/",
    uk: "https://certn.co/emea/service-agreement/",
    au: "https://certn.co/anz/service-agreement/",
    us: "https://certn.co/us/service-agreement/",
  };

  if (language?.trim().toLowerCase().startsWith("fr")) {
    return "https://certn.co/conditions-de-service/";
  }

  try {
    const region = getRegionKey()?.toLowerCase();
    return regionUrlMap[region] ?? regionUrlMap.ca;
  } catch (error) {
    console.error("Error getting region key:", error);
    return regionUrlMap.ca;
  }
}

export function getWebsiteTermsUrl(language: string | undefined) {
  if (language?.toLowerCase().startsWith("fr")) {
    return "https://certn.co/conditions-dutilisation-du-site-web/";
  }
  return "https://vault.pactsafe.io/s/5d800911-f26c-4e3a-884d-85117a81799b/legal.html?g=37964#contract-b1hg-isli";
}
